import { render, staticRenderFns } from "./overview-card.vue?vue&type=template&id=58635892&scoped=true&"
import script from "./overview-card.vue?vue&type=script&lang=js&"
export * from "./overview-card.vue?vue&type=script&lang=js&"
import style0 from "./overview-card.vue?vue&type=style&index=0&id=58635892&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58635892",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VFlex,VLayout,VProgressLinear})
